// Textos en español de las pantallas propias de Raftel (se suman al catálogo es-MX).
export const raftelSpanishMessages = {
  resources: {
    directory: {
      name: "Directorio |||| Directorio",
      empty:
        "Ninguna empresa coincide con los filtros. Quita alguno para ver más resultados.",
    },
    templates: {
      name: "Plantilla |||| Plantillas",
      empty: "Aún no hay plantillas. Crea una para poder enviar mensajes.",
    },
    sequences: {
      name: "Cadencia |||| Cadencias",
      empty:
        "Aún no hay cadencias. Crea una para inscribir contactos automáticamente.",
    },
    sequence_steps: {
      name: "Paso |||| Pasos",
    },
    do_not_contact: {
      name: "No contactar |||| No contactar",
      empty: "La lista de no contactar está vacía",
    },
  },
};
